/**
 * 页签图标。框架自带图标集里没有合适的，四个页签原本全用同一个对勾 ——
 * 一排一模一样的图标等于没有图标，只能靠文字辨认，触屏上很吃亏。
 * 选中态用实心填充做区分，而不是只靠颜色（色觉障碍下颜色不可靠）。
 */
const P = {
  fill: 'none', stroke: 'currentColor', strokeWidth: 1.9,
  strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
}

export const IconToday = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden>
    <rect x="3" y="5" width="18" height="16" rx="4.5" {...P} />
    <path d="M3 10h18M8 3v4M16 3v4" {...P} />
    {active && <circle cx="12" cy="15.5" r="2.5" fill="currentColor" />}
  </svg>
)

export const IconGoal = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden>
    <circle cx="12" cy="12" r="8.5" {...P} />
    <circle cx="12" cy="12" r="4.6" {...P} />
    <circle cx="12" cy="12" r={active ? 2.1 : 1.3} fill="currentColor" />
  </svg>
)

export const IconMoney = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden>
    <path d="M3 8.5A3.5 3.5 0 0 1 6.5 5h11A3.5 3.5 0 0 1 21 8.5v7a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 3 15.5z" {...P} />
    <path d="M7 5V3.6" {...P} />
    {active ? <circle cx="16.8" cy="12" r="1.9" fill="currentColor" /> : <circle cx="16.8" cy="12" r="1.5" {...P} />}
  </svg>
)

export const IconTrail = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden>
    <path d="M6 10.6v9.4" {...P} />
    <path d="M12 7h8M12 12.5h8M12 18h5" {...P} />
    {active ? <circle cx="6" cy="7" r="2.9" fill="currentColor" /> : <circle cx="6" cy="7" r="2.4" {...P} />}
  </svg>
)

export const IconAdmin = ({ active }: { active?: boolean }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden>
    <path d="M12 3.4 20 6.8v5.6c0 4.2-3.2 7.4-8 8.5-4.8-1.1-8-4.3-8-8.5V6.8z" {...P} />
    {active && <path d="m8.8 12.2 2.3 2.3 4.3-4.6" {...P} strokeWidth={2.3} />}
  </svg>
)
